var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/NumberedList/NumberedList.js",
  _this = this;
import React from 'react';
import styled from 'styled-components';
import NumberListItem from './NumberedListItem';
var List = styled('ol').withConfig({
  displayName: "NumberedList__List",
  componentId: "sc-2v9256-0"
})(["counter-reset:section;list-style-type:none;padding-left:0;", " ", ""], function (_ref) {
  var level = _ref.level;
  return (level === 1 || level === 2) && "\n      position: relative;\n      left: -50px;\n\n      > li {\n         width: calc(100% + 41px);\n      }\n\n      @media (max-width: 1192px) {\n        left: -44px;\n      }\n\n      @media (max-width: 320px) {\n         left: -38px;\n      }\n  ";
}, function (_ref2) {
  var level = _ref2.level;
  return level === 3 && "\n      > li {\n         width: calc(100% + 18px);\n      }\n\n  ";
});
var DepthContext = /*#__PURE__*/React.createContext(0);
var NumberedList = function NumberedList(_ref3) {
  var children = _ref3.children,
    _ref3$simple = _ref3.simple,
    simple = _ref3$simple === void 0 ? false : _ref3$simple;
  var level = React.useContext(DepthContext);
  return /*#__PURE__*/React.createElement(DepthContext.Provider, {
    value: level + 1,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(List, {
    level: level,
    simple: simple,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 7
    }
  }, React.Children.map(children, function (child) {
    return /*#__PURE__*/React.cloneElement(child, {
      simple: simple && !Array.isArray(child.props.children) && level === 0,
      level: level
    });
  })));
};
NumberedList.Item = NumberListItem;
NumberListItem.defaultProps = {
  simple: false
};
export default NumberedList;